import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import ComplianceApi from '../server/ComplianceApi';

import * as schema from '../schema/compliance';

import ComplianceStore from '../stores/ComplianceStore';
import { openDialog } from './DialogActionCreator';
import { ComplianceDialogs } from '../constants/Dialogs';

export const listCompliances = () => {
    const types = {
        request:    ActionTypes.COMPLIANCE_LIST_REQUEST,
        success:    ActionTypes.COMPLIANCE_LIST_SUCCESS,
        failure:    ActionTypes.COMPLIANCE_LIST_FAILURE
    };

    return Dispatcher.dispatchAsync(ComplianceApi.list(), types, {}, schema.complianceList);
};

export const getCompliance = (id) => {
    const types = {
        request:    ActionTypes.COMPLIANCE_INFO_REQUEST,
        success:    ActionTypes.COMPLIANCE_INFO_SUCCESS,
        failure:    ActionTypes.COMPLIANCE_INFO_FAILURE
    };
    return Dispatcher.dispatchAsync(ComplianceApi.get(id), types, {}, schema.compliance);
};

export const searchCompliance = (searchText) => {
    const types = {
        request:    ActionTypes.COMPLIANCE_LIST_REQUEST,
        success:    ActionTypes.COMPLIANCE_LIST_SUCCESS,
        failure:    ActionTypes.COMPLIANCE_LIST_FAILURE
    };

    return Dispatcher.dispatchAsync(ComplianceApi.list({searchText}), types, {}, schema.complianceList);
};

export const createCompliance = () => Dispatcher.throttleDispatch({ type: ActionTypes.COMPLIANCE_NEW });
export const editCompliance = (id) => {
    const callThen = (id) => {
        const draft = ComplianceStore.get(id);
        return Dispatcher.dispatch({ type: ActionTypes.COMPLIANCE_EDIT, payload: {draft} });
    };

    if (!ComplianceStore.get(id)) {
        getCompliance(id).then(() => callThen(id));
    } else {
        return callThen(id);
    }
};

export const discardCompliance = () => Dispatcher.dispatch({ type: ActionTypes.COMPLIANCE_DISCARD });
export const updateComplianceDraft = (field, value) => Dispatcher.dispatch({ type: ActionTypes.COMPLIANCE_UPDATE_DRAFT, payload: {field, value}});
export const addSkill = (skill) => Dispatcher.dispatch({ type: ActionTypes.COMPLIANCE_ADD_SKILL, payload: { skill } });
export const removeSkill = (skillId) => Dispatcher.dispatch({ type: ActionTypes.COMPLIANCE_REMOVE_SKILL, payload: {skillId }});

const insertCompliance = (draft) => {
    draft.id = `INS-${Date.now()}`;
    const types = {
        request:    ActionTypes.COMPLIANCE_ADD_REQUEST,
        success:    ActionTypes.COMPLIANCE_ADD_SUCCESS,
        failure:    ActionTypes.COMPLIANCE_ADD_FAILURE
    };

    return Dispatcher.dispatchAsync(ComplianceApi.insert(draft), types, {draft}, schema.compliance);
};

const updateCompliance = (draft) => {
    const { id } = draft;
    const current = ComplianceStore.get( id );
    const types = {
        request:    ActionTypes.COMPLIANCE_UPDATE_REQUEST,
        success:    ActionTypes.COMPLIANCE_UPDATE_SUCCESS,
        failure:    ActionTypes.COMPLIANCE_UPDATE_FAILURE
    };
    return Dispatcher.dispatchAsync(ComplianceApi.update(id, draft), types, {draft, current}, schema.compliance);
};

export const deleteCompliance = (id) => {
    const types = {
        request:    ActionTypes.COMPLIANCE_DELETE_REQUEST,
        success:    ActionTypes.COMPLIANCE_DELETE_SUCCESS,
        failure:    ActionTypes.COMPLIANCE_DELETE_FAILURE
    };

    return Dispatcher.dispatchAsync(ComplianceApi.delete(id), types, {id});
};

export const saveCompliance = () => {
    const draft = ComplianceStore.getDraft();
    if (draft.id && Number(draft.id)) {
        return updateCompliance(draft);
    } else {
        return insertCompliance(draft);
    }
};

export const saveAndDiscardCompliance = () => saveCompliance().then(discardCompliance);
export const createComplianceFromProgramme = (name, programmeId) => insertCompliance({name, programmeId});
export const openAssignUsersDialog = (complianceId) => openDialog(ComplianceDialogs.ASSIGN_USERS, {complianceId, filterId: null});
export const openClearUsersDialog = (complianceId, userCount) => openDialog(ComplianceDialogs.COMPLIANCE_CLEAR_USERS, {complianceId, userCount});
export const openDeleteDialog = (complianceId, userCount = 0) => openDialog(ComplianceDialogs.COMPLIANCE_DELETE, {complianceId, userCount});

export const assignUsersByFilter = (complianceId, filterId) => {
    const types = {
        request:    ActionTypes.COMPLIANCE_ASSIGN_USERS_REQUEST,
        success:    ActionTypes.COMPLIANCE_ASSIGN_USERS_SUCCESS,
        failure:    ActionTypes.COMPLIANCE_ASSIGN_USERS_FAILURE
    };
    return Dispatcher.dispatchAsync(ComplianceApi.assignByFilter(complianceId, filterId), types, {complianceId}, schema.compliance);
};

export const clearAssignedUsers = (complianceId) => {
    const types = {
        request:    ActionTypes.COMPLIANCE_CLEAR_USERS_REQUEST,
        success:    ActionTypes.COMPLIANCE_CLEAR_USERS_SUCCESS,
        failure:    ActionTypes.COMPLIANCE_CLEAR_USERS_FAILURE
    };
    return Dispatcher.dispatchAsync(ComplianceApi.clearAssignedUsers(complianceId), types, {complianceId}, schema.compliance);
};

export const getComplianceProgress = (complianceId, params = {}) => {
    const types = {
        request:    ActionTypes.COMPLIANCE_PROGRESS_REQUEST,
        success:    ActionTypes.COMPLIANCE_PROGRESS_SUCCESS,
        failure:    ActionTypes.COMPLIANCE_PROGRESS_FAILURE
    };

    return Dispatcher.dispatchAsync(ComplianceApi.listProgress(complianceId, params), types, {complianceId, ...params});
};
